// Utilitaire centralisé pour les URLs d'images statiques
// Vide = même origine (le backend sert le front en production).
// Jamais "undefined" : une variable absente cassait toutes les URLs d'images.
const API = process.env.REACT_APP_BACKEND_URL || '';

/** Image web optimisée (WebP) servie par le backend. */
export const img = (name) => `${API}/api/images/${name}.webp`;

export const IMAGES = {
  // Hero
  heroDoudou: img('hero-doudou'),
  heroTexture: img('hero-texture'),
  // Atelier / Brand
  atelierMargot: img('atelier-margot'),
  atelierCouture: img('atelier-couture'),
  atelierTissus: img('atelier-tissus'),
  atelierDetails: img('atelier-details'),
  // About
  aboutHero: img('about-hero'),
  aboutCut: img('about-process-cut'),
  aboutSew: img('about-process-sew'),
  aboutFinish: img('about-process-finish'),
  aboutPackaging: img('about-packaging'),
  // Journal (une image par article, toutes présentes dans backend/static/images)
  journalPlacard: img('about-hero'),
  journalPage: img('sylvette-la-crevette-livre'),
  journalAtelier: img('atelier-couture'),
  journalCollection: img('hero-doudou'),
  journalRituel: img('home-newsletter'),
  // Home
  homeNewsletter: img('home-newsletter'),
  homeBg: img('home-bestsellers-bg'),
  journalBg: '/images/bg-journal.webp',
};
